import { type DeviceDetails } from '../types/DeviceDetails';
import { type DeviceType } from '../types/DeviceType';

export const hydrateDeviceParentRecursive = (
  device: DeviceType,
  devices: DeviceType[]
): DeviceDetails => {
  const parent =
    device.parentDeviceTypeId &&
    devices.find((d) => d.id === device.parentDeviceTypeId);

  return {
    ...device,
    parent: parent ? hydrateDeviceParentRecursive(parent, devices) : undefined,
  };
};
